import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { UserService } from '../../services/user.service';
@Component({
  selector: 'sd-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})

export class BreadcrumbComponent implements OnInit {

  @Input() data: any;
  daysText: any;
  breadcrumb = [{
    'name': 'Home',
    'link': '/'
  }];

  constructor(
    public global: GlobalService,
    public user: UserService,
  ) {
  }

  // ngOnInit() {
  //     console.log(this.data);
  //     if (this.data.isMessage) {
  //         this.breadcrumb = this.data.breadcrumb;
  //     } else {
  //         this.data.breadcrumb.forEach(item => {
  //             this.breadcrumb.push(item);
  //         });
  //     }
  //     console.log('Breadcrumb: ', this.breadcrumb);
  // }

  ngOnInit() {

    if (this.user.expdays == 0) {
      this.daysText = "today";
    } else if (this.user.expdays == 1) {
      this.daysText = "1 day";
    } else if (this.user.expdays > 1) {
      this.daysText = this.user.expdays + " days";
    }

    this.updateBreadcrumb();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && !changes.data.firstChange) {
      this.updateBreadcrumb();
    }
  }

  private updateBreadcrumb() {
    this.breadcrumb = [{
      'name': 'Home',
      'link': '/'
    }];

    if (this.data?.isMessage) {
      this.breadcrumb = this.data.breadcrumb;
    } else if (this.data?.breadcrumb) {
      this.data.breadcrumb.forEach((item: any) => {
        this.breadcrumb.push(item);
      });
    }
  }
}
